export default __webpack_public_path__ + "assets/icons/phone.b79cb1e2.svg";